__turbopack_context__.v({
  "column": "WhatView-module__1Rshba__column",
  "columnItem": "WhatView-module__1Rshba__columnItem",
  "columnItemsWrapper": "WhatView-module__1Rshba__columnItemsWrapper",
  "columnsSection": "WhatView-module__1Rshba__columnsSection",
  "footer": "WhatView-module__1Rshba__footer",
  "grid": "WhatView-module__1Rshba__grid",
  "title": "WhatView-module__1Rshba__title",
  "wrapper": "WhatView-module__1Rshba__wrapper",
});
